import { DashedTag } from '@/components/chariot-ui';
import { StatusChip, StatusChipVariant } from '@/components/ui/status-chip';
import { Status } from '@/sections/customerManagement/types';
import { CUSTOMER_TYPE_LABELS, CustomerTypeValue } from '@/types';

const statusConfig: Record<
  Status,
  { variant: StatusChipVariant; tooltip: string }
> = {
  Active: { variant: 'info', tooltip: 'Subscription is currently active' },
  Upcoming: {
    variant: 'neutral',
    tooltip: 'Subscription starts within 30 days',
  },
  Completed: { variant: 'critical', tooltip: 'Subscription has ended' },
  Paused: { variant: 'high', tooltip: 'Subscription is paused' },
  Setup: { variant: 'muted', tooltip: 'Account setup in progress' },
};

export const StatusBadge = ({ status }: { status: Status }) => {
  const config = statusConfig[status];
  if (!config) return null;
  return (
    <StatusChip
      label={status}
      variant={config.variant}
      tooltip={config.tooltip}
    />
  );
};

export const CustomerTypeTag = ({
  type,
}: {
  type?: CustomerTypeValue | { value: CustomerTypeValue };
}) => {
  const typeValue = typeof type === 'object' ? type?.value : type;

  if (!typeValue) return '-';
  return <DashedTag label={CUSTOMER_TYPE_LABELS[typeValue] || typeValue} />;
};
